import { Box } from "@mui/material";
import { ReactComponent as Export } from "assets/Export.svg";
import ThemeContext from "components/app/Context";
import { useTranslate } from "hooks/useTranslate";
import { useContext, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { fileExportHandler, getBrandsCodesByName } from "utils/CommonFunctions";
import Button from "../Button";
import DateRangePicker from "../DateRangePicker";
import DialogFormation from "../DialogFormation";
import MultipleSelectCheckmarks from "../dropdowns/MultiSelect";
import Typography from "../Typography";
import "./index.scss";

interface Props {
  label?: string;
  URL: string;
  data?: any;
  serviceType: string;
  isGet?: boolean;
  isDateRangeApplicable?: boolean;
}

interface DateRange {
  startDate: Date | null;
  endDate: Date | null;
}

interface AppliedFilters {
  brand: string[] | [];
  region: string[] | [];
}

const ExportButton = (props: Props) => {
  const translate = useTranslate();
  const { isMobileScreen } = useContext(ThemeContext);

  const { label, isGet = false, isDateRangeApplicable = false } = props;

  const noOfRows = useAppSelector((state) => state.app.tableHelperData?.noOfRows);

  const [showRangeSelector, setShowRangeSelector] = useState<boolean>(false);
  const [dateRange, setDateRange] = useState<DateRange>({ startDate: null, endDate: null });
  const [customFilterApplied, setCustomFilterApplied] = useState<AppliedFilters>({ brand: [], region: [] });
  const customFilters = useAppSelector((state: any) => state.CustomFiterSlice.customFilters);

  const onExportClick = (url?: string) => fileExportHandler(url ?? props.URL, props.serviceType, props.data, isGet);

  const buildExportUrl = () => {
    if (!dateRange.startDate || !dateRange.endDate) return null;
    const formatDate = (date: Date) => date.toLocaleDateString("en-CA");
    const start = formatDate(dateRange.startDate);
    const end = formatDate(dateRange.endDate);
    return `${props.URL}?startDate=${start}&endDate=${end}&brandCodes=${customFilterApplied.brand.join(
      ","
    )}&regions=${encodeURIComponent(customFilterApplied.region.join("|"))}`;
  };

  const handleFilters = (type: string, value: string[]) => {
    const modiefiedVal = getBrandsCodesByName(value, customFilters.brandCodes, type);
    setCustomFilterApplied((prev: any) => ({
      ...prev,
      [type]: modiefiedVal
    }));
  };

  const handleCancel = (value: boolean) => {
    setShowRangeSelector(value);
    setCustomFilterApplied({ brand: [], region: [] });
  };

  return noOfRows > 0 ? (
    <>
      <div
        className="export-button"
        onClick={() => {
          if (isDateRangeApplicable) handleCancel(true);
          else onExportClick();
        }}
      >
        <Export />
        <div className="export-label">
          <Typography variant="body2" color={tokens.Text.General.Secondary}>
            {label || `Export`}
          </Typography>
        </div>
      </div>
      {showRangeSelector && (
        <DialogFormation
          title={translate("export.header")}
          openDialog={showRangeSelector}
          handleClose={() => {
            handleCancel(false);
          }}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button
                variant="secondary"
                label="Cancel"
                onClick={() => handleCancel(false)}
                width={isMobileScreen ? "50%" : "25%"}
              />
              <Button
                disabled={!dateRange?.startDate || !dateRange?.endDate}
                variant="primary"
                label="Download excel"
                onClick={() => {
                  onExportClick(buildExportUrl() ?? props.URL);
                }}
                width={isMobileScreen ? "50%" : "25%"}
              />
            </div>
          }
        >
          <Box
            width="100%"
            alignItems={"flex-start"}
            justifyContent="flex-start"
            textAlign={"center"}
            display={"flex"}
            flexDirection="column"
            gap={"20px"}
            paddingRight={isMobileScreen ? "15px" : "50px"}
            paddingLeft={"15px"}
            marginTop={"10px"}
          >
            <div className="brand-region-filter">
              <MultipleSelectCheckmarks
                minWidth={isMobileScreen ? "100%" : "284px"}
                name="brand"
                label="Brand"
                options={customFilters.brandCodes}
                initialValues={[]}
                onChange={(value: any) => {
                  handleFilters("brand", value);
                }}
                isInitialValuesRender={true}
                isBgWhite={true}
              />
              <MultipleSelectCheckmarks
                minWidth={isMobileScreen ? "100%" : "284px"}
                name="region"
                label="Region"
                options={customFilters.region}
                initialValues={[]}
                onChange={(value: any) => {
                  handleFilters("region", value);
                }}
                isInitialValuesRender={true}
                isBgWhite={true}
              />
            </div>
            <DateRangePicker dateRange={dateRange} setDateRange={setDateRange} />
          </Box>
        </DialogFormation>
      )}
    </>
  ) : (
    <></>
  );
};

export default ExportButton;
